import React, { useState, useEffect } from 'react'

import PropTypes from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import Icon from './Icon/Icon'

function ComponentSearch({ onSearchSubmit, searchTerm = '', onTermChange, isDisabled = false, locale = '' }) {
  const [searchPlaceholder, setSearchPlaceholder] = useState('')

  useEffect(() => {
    const translated = i18n.t('projects.searchPlaceholder', { ns: 'rails', lng: locale })
    setSearchPlaceholder(translated)
  }, [locale])
  
  return (
    <form onSubmit={onSearchSubmit} className="component-search">
      <div className="search-form">
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={onTermChange}
          className="form-control"
          disabled={isDisabled}
        />

        <button type="submit" className="btn btn-transparent" disabled={isDisabled}>
          <Icon type={['far', 'search']} color="grey-dark" className="info-icon" notSpaced />
        </button>
      </div>
    </form>
  )
}

ComponentSearch.propTypes = {
  onSearchSubmit: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  onTermChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  locale: PropTypes.string,
}

export default ComponentSearch
